const pmsConfigs = {
    guesty: {
      name: "Guesty",
    },
    streamline: {
      name: "Streamline",
    },
    hostaway: {
      name: "Hostaway",
    },
    track: {
      name: "Track",
    },
        all: {
      name: "Guesty, Streamline, and Akia",
    },
    // Add more PMS platforms as needed
  };
  
  export default pmsConfigs;
  